import WasmController from "react-lib/frameworks/WasmController";
import * as MobTransformI from "./MobTransformInterface";

export default class MobTransformController extends WasmController<
  MobTransformI.State,
  MobTransformI.Event,
  MobTransformI.Data,
  MobTransformI.Props
> {
  constructor(
    getState: () => MobTransformI.State,
    setState,
    window: any
  ) {
    super(getState, setState, window, MobTransformI.DataInitial);
  }

  handleEvent = async (e: MobTransformI.Event) => {
    console.log(e.message, e.params);
    switch (e.message) {
      // Setup
      case "DidMount":
        MobTransformI.DidMount(this, e.params);
        return;

      case "DidUpdate":
        MobTransformI.DidUpdate(this, e.params);
        return;

      case "HandleSignIn":
        MobTransformI.LoginIssara(this, e.params);
        return

      case "HandleNextViewRegister":
        MobTransformI.HandleNextViewRegister(this, e.params);
        return

      case "HandleSetViewIndexRegister":
        MobTransformI.HandleSetViewIndexRegister(this, e.params);
        return

      case "HandleSetValueRegisterInfo":
        MobTransformI.HandleSetValueRegisterInfo(this, e.params);
        return

      case "HandleSetValueChangePassword":
        MobTransformI.HandleSetValueChangePassword(this, e.params);
        return

      case "HandleSetInputEmail":
        MobTransformI.HandleSetInputEmail(this, e.params);
        return

      case "HandleConfirmChangePassword":
        MobTransformI.HandleConfirmChangePassword(this, e.params);
        return

      case "HandleSetInputEmailRequest":
        MobTransformI.HandleSetInputEmailRequest(this, e.params);
        return

      case "HandleEmailRequest":
        MobTransformI.HandleEmailRequest(this, e.params);
        return

      case "HandleSetOpenModCheckEmail":
        MobTransformI.HandleSetOpenModCheckEmail(this, e.params);
        return

      case "HandleSignInByEmail":
        MobTransformI.HandleSignInByEmail(this, e.params);
        return

      case "HandleGoBackSignInEmail":
        MobTransformI.HandleGoBackSignInEmail(this, e.params);
        return

      case "HandleCloseMessage":
        MobTransformI.HandleCloseMessage(this, e.params);
        return

      case "GetPatientDetail":
        MobTransformI.GetPatientDetail(this, e.params);
        return

      case "HandleGoBackVerify":
        MobTransformI.HandleGoBackVerify(this, e.params);
        return

      case "HandleRouteChange":
        MobTransformI.HandleRouteChange(this, e.params);
        return

      default:
        let testExhausitve: never = e;
    }
    console.log("-- Unhandled case");
  };
}
